import { fetchChannels } from 'api/Channels/actions'
import { fetchCountries } from 'api/Countries/actions'
import { COUNTRIES_KEY } from 'api/Group/constants'
import { ChannelsList } from 'ChannelsList'
import { ChannelSummary } from 'ChannelSummary'
import classNames from 'classnames'
import {
  selectChannelsType,
  selectRefetchParams,
  selectSubListTypeSelected,
  selectTabCountriesList,
  selectTabRequestParams,
} from 'data/selectors'
import { ListDetails } from 'ListDetails'
import { selectIsListDetailsOpen } from 'ListDetails/selectors'
import { LoadingOverlay } from 'LoadingOverlay'
import { selectLanguage } from 'locale/selectors'
import React, { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SaleTypesList } from 'SaleTypesList'
import { selectLastReFetchTime } from 'store/reducers/lastReFetchTime'

import Box from '@mui/material/Box'

import useStyles from './useStyles'

interface Props {
  level?: number
}

function TabCountriesList({ level = 1 }: Props) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { isLoading, list } = useSelector(selectTabCountriesList)
  const channelsType = useSelector(selectChannelsType)
  const subListTypeSelected = useSelector(selectSubListTypeSelected)
  const lastReFetchTime = useSelector(selectLastReFetchTime)
  const tabRequestParams = useSelector(selectTabRequestParams)
  const refetchParams = useSelector(selectRefetchParams)
  const showSkeletonLoader = list.length === 0 && isLoading
  const isActive = channelsType === 'countries'
  const language = useSelector(selectLanguage).toUpperCase()
  const isToggled = useSelector(selectIsListDetailsOpen)

  useEffect(() => {
    if (isActive)
      dispatch(
        fetchCountries({
          ...refetchParams,
          [COUNTRIES_KEY]: true,
        }),
      )
  }, [isActive, lastReFetchTime, refetchParams, dispatch])

  return (
    <LoadingOverlay isLoading={showSkeletonLoader} shouldHide={!isActive}>
      <Box minHeight={showSkeletonLoader ? '6rem' : '0'}>
        {list.map(data => {
          const { countryId } = data
          const fetchList = () => {
            if (subListTypeSelected === 'channels') {
              dispatch(fetchChannels({ ...tabRequestParams, countryId }))
            }
          }

          return (
            <ChannelSummary
              key={`${COUNTRIES_KEY}.${countryId}`}
              className={classNames({ [classes.details]: isToggled })}
              countryId={countryId}
              data={data}
              fetchList={fetchList}
              isLoading={isLoading}
              label={data[`countryName${language}`] || ''}
              type="countries"
            >
              <>
                <ListDetails countryId={countryId} data={data} isLoading={isLoading} type="countries" />
                {subListTypeSelected === 'saleTypes' && !isToggled && <SaleTypesList countryId={countryId} hideFlag={true} />}
                {subListTypeSelected === 'channels' && !isToggled && <ChannelsList countryId={countryId} />}
              </>
            </ChannelSummary>
          )
        })}
      </Box>
    </LoadingOverlay>
  )
}

export default memo(TabCountriesList)
